import GridPattern from "@/components/magicui/grid-pattern";
import { cn } from "@/lib/utils";

export function QRFormLayout({ children, bgColor = "bg-ash-100" }: { children: React.ReactNode; bgColor?: string }) {
  return (
    <div className={cn("flex flex-col items-center pt-14", bgColor)}>
      <GridPattern
        width={68}
        height={68}
        x={-1}
        y={-1}
        className={cn("mask-[radial-gradient(700px_circle_at_center,white,transparent)]", "absolute")}
      />
      <div className="w-full relative max-w-5xl">{children}</div>
    </div>
  );
}
